import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { Session } from '../interfaces/session';
import { environment } from 'src/environments/environment';

export const STORAGE_KEY = 'session';
export const TOKEN_KEY = 'token';

@Injectable({
  providedIn: 'root',
})
export class SessionService {

  private readonly logoutUrl = `${environment.externalUrls.bff}/auth/logout`;
  private readonly sessionSub = new BehaviorSubject<Session | undefined>(this.get());
  public readonly session$ = this.sessionSub.asObservable();

  constructor(private httpClient: HttpClient) {}

  get sessionToken() {
    const token = window.localStorage.getItem(TOKEN_KEY);

    if (token) {
      return JSON.parse(token);
    }

    return undefined;
  }

  set(session: Session) {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(session));
    this.sessionSub.next(session);
  }

  get(): Session | undefined {
    const data = window.localStorage.getItem(STORAGE_KEY);

    if (data) {
      return JSON.parse(data);
    }

    return undefined;
  }

  exit() {
    this.httpClient
      .post(this.logoutUrl, null, { withCredentials: true })
      .subscribe({
        next: () => this.redirectAfterLogout(),
        error: () => this.redirectAfterLogout(),
      });
  }

  private redirectAfterLogout() {
    window.localStorage.removeItem(STORAGE_KEY);
    window.open(
      `${environment.externalUrls.platform}?logout=${encodeURIComponent(true)}`,
      '_self'
    );
  }

  exitWithRecovery() {
    window.localStorage.removeItem(STORAGE_KEY);
    window.open(
      `${environment.externalUrls.platform}?logout=${encodeURIComponent(true)}&access=recovery`,
      '_self'
    );
  }

  processURLToken(token?: string) {
    if (!token) {
      return;
    }

    window.localStorage.removeItem(STORAGE_KEY);
    window.localStorage.setItem(TOKEN_KEY, JSON.stringify(token));

    const url = new URL(window.location.href);
    url.searchParams.delete('token');
  }

  resetToken() {
    window.localStorage.removeItem(TOKEN_KEY);
  }
}
